import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import ErrorIcon from "src/images/error.svg";
import * as styles from "./UnAuthenticatedModal.css.ts";

interface UnAuthenticatedModalProps {
  handleLogin: () => void;
}

const UnAuthenticatedModal: React.FC<UnAuthenticatedModalProps> = ({
  handleLogin,
}) => {
  return (
    <div>
      <div>
        <img src={ErrorIcon} alt="error icon" />
        <Typography.h2 className={styles.unAuthenticatedModalHeader}>
          Oops! You're Not Logged In{" "}
        </Typography.h2>
        <Typography.p className={styles.unAuthenticatedModalText}>
          Please click the button below to continue.
        </Typography.p>
      </div>
      <div className={styles.lineDivider} />
      <div className={styles.unAuthenticatedModalButton}>
        <Button themeColor="primary" onClick={handleLogin}>
          Log in
        </Button>
      </div>
    </div>
  );
};

export default UnAuthenticatedModal;
